/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActiveWidgetContext
 */
export interface ActiveWidgetContext {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ActiveWidgetContext
     */
    content: { [key: string]: any; };
}

/**
 * Check if a given object implements the ActiveWidgetContext interface.
 */
export function instanceOfActiveWidgetContext(value: object): value is ActiveWidgetContext {
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function ActiveWidgetContextFromJSON(json: any): ActiveWidgetContext {
    return ActiveWidgetContextFromJSONTyped(json, false);
}

export function ActiveWidgetContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActiveWidgetContext {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
    };
}

export function ActiveWidgetContextToJSON(json: any): ActiveWidgetContext {
    return ActiveWidgetContextToJSONTyped(json, false);
}

export function ActiveWidgetContextToJSONTyped(value?: ActiveWidgetContext | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': value['content'],
    };
}

